import { MetricFunction, MetricsAggregation } from '../shared/model/metric';

export const metricSwitchOptionsMap: {
  [key: string]: {
    metric: MetricsAggregation;
    metricFunction?: MetricFunction;
  };
} = {
  'relevance-sum': {
    metric: MetricsAggregation.RELEVANCE,
    metricFunction: MetricFunction.SUM
  },
  'relevance-avg': {
    metric: MetricsAggregation.RELEVANCE,
    metricFunction: MetricFunction.AVG
  },
  count: {
    metric: MetricsAggregation.COUNT
  },
  'smart-relevance': {
    metric: MetricsAggregation.SMART_RELEVANCE
  },
  'count-log-and-relevance': {
    metric: MetricsAggregation.COUNT_LOG_AND_RELEVANCE
  },
  'count-log-and-topic-score': {
    metric: MetricsAggregation.COUNT_LOG_AND_TOPIC_SCORE
  },
  'dumb-bias-correction': {
    metric: MetricsAggregation.DUMB_BIAS_CORRECTION
  },
  'normalized-bias-correction': {
    metric: MetricsAggregation.NORMALIZED_BIAS_CORRECTION
  },
  'smart-relevance-with-count': {
    metric: MetricsAggregation.SMART_RELEVANCE,
    metricFunction: MetricFunction.LOG_COUNT
  },
  'dumb-bias-correction-with-count': {
    metric: MetricsAggregation.DUMB_BIAS_CORRECTION,
    metricFunction: MetricFunction.LOG_COUNT
  },
  'normalized-bias-correction-with-count': {
    metric: MetricsAggregation.NORMALIZED_BIAS_CORRECTION,
    metricFunction: MetricFunction.LOG_COUNT
  }
};
